<template>
  <div class="header-flag" aria-hidden="true">
    <svg width="60" height="24" viewBox="0 0 60 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M20 0H40C40 9.37258 40 14.6274 40 24H20V0Z" fill="#5C8BFB" />
      <rect width="20" height="24" fill="white" />
      <rect x="40" width="20" height="24" fill="#FECC0D" />
    </svg>
  </div>
</template>

<style scoped lang="scss">
.header-flag {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 24px;

  svg {
    box-shadow: 0 0 20px -8px var(--color-darker);
  }
}
</style>

